import { useCustom } from "@refinedev/core";
import { useMarketplaceStore } from "../../../../store/useMarketplaceStore";
import { useSearchParams } from "react-router-dom";

type CountResponse = {
  amazonDiscoveryQueueCount: number;
  notFoundCount: number;
  inCriteriaQueueCount: number;
  outOfCriteriaCount: number;
  pendingApproveCount: number;
  amazonListingQueueCount: number;
  activeCount: number;
  inactiveCount: number;
  incompleteCount: number;
  deletedCount: number;
  acceptedCount: number;
};

export const useInventoryCounts = () => {
  const [searchParams] = useSearchParams();
  const tabParam = searchParams.get("tab") ?? "active";

  const selectedCountry = useMarketplaceStore((state) => state.selectedCountry);

  const { data, isLoading } = useCustom<CountResponse>({
    url: selectedCountry ? `store/${selectedCountry.id}/product/count` : "",
    method: "get",
    queryOptions: {
      enabled: !!selectedCountry,
      // "data" & "default" are refine keys and they are required for invalidate hook to work
      // tabParam is used to invalidate the query when the tab changes
      queryKey: ["data", "default", tabParam, selectedCountry?.id],
    },
  });

  const counts = {
    discoveryQueue: data?.data?.amazonDiscoveryQueueCount ?? 0,
    notFound: data?.data?.notFoundCount ?? 0,
    filterQueue: data?.data?.inCriteriaQueueCount ?? 0,
    outOfCriteria: data?.data?.outOfCriteriaCount ?? 0,
    pendingApproval: data?.data?.pendingApproveCount ?? 0,
    amazonListingQueue: data?.data?.amazonListingQueueCount ?? 0,
    active: data?.data?.activeCount ?? 0,
    inactive: data?.data?.inactiveCount ?? 0,
    incomplete: data?.data?.incompleteCount ?? 0,
  };

  return { counts, loading: isLoading };
};
